module.exports = __webpack_public_path__ + "img/back-fill.1c2429b4.svg";